<template>
  <div :class="classes.statisticsWrapper">
    <StatisticSlider
      v-for="stat in statistics"
      :key="stat.text"
      :class="[classes.slider, 'statistics']"
      :text="stat.text"
      :format="stat.format"
      :reversed="stat.reversed"
      :leftValue="stat.left"
      :rightValue="stat.right"
      :leftColor="leftColor"
      :rightColor="rightColor"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { Brand } from "@fresh8/types/src";
import StatisticSlider from "./StatisticsSlider.vue";
import { injectTeamColors } from "../lib/teamBranding";
import { H2HFormatedData } from "../hooks/useH2HStatistics";

const useStyles = createUseStyles({
  statisticsWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  },
  slider: {
    "&:last-of-type": {
      paddingBottom: "8px"
    }
  }
});

export default defineComponent({
  components: {
    StatisticSlider
  },
  props: {
    statistics: {
      type: Object as PropType<Array<H2HFormatedData>>,
      required: true
    }
  },
  setup(props) {
    const brandContext = injectBrand() || ({} as BrandContext);
    const teamColorsContext = injectTeamColors();

    const classesRef = useStyles();

    const leftColor = computed(() => {
      if (brandContext.adTemplate.value?.h2hCard?.useTeamColors) {
        return teamColorsContext.colors.value.home?.banner.background;
      }

      return undefined;
    });

    const rightColor = computed(() => {
      if (brandContext.adTemplate.value?.h2hCard?.useTeamColors) {
        return teamColorsContext.colors.value.away?.banner.background;
      }

      return undefined;
    });

    return {
      leftColor,
      rightColor,
      classes: classesRef,
      fixtureNameStyle: {
        get: (brand: Brand) => brand.adTemplate.market.teamNameFont,
        set: (brand: Brand, value: string) =>
          (brand.adTemplate.market.teamNameFont = value)
      }
    };
  }
});
</script>
